const DEFAULT_PHONE_COUNTRY_CODE = '57';
const PHONE_REGEX = /^[1-9]\d{7,14}$/;

export function normalizePhone(phone: string): string {
  const compact = phone.trim().replace(/[^\d+]/g, '');
  const digits = compact.startsWith('00') ? compact.slice(2).replace(/\D/g, '') : compact.replace(/\D/g, '');

  if (!digits) return '';
  return digits.startsWith(DEFAULT_PHONE_COUNTRY_CODE) ? digits : `${DEFAULT_PHONE_COUNTRY_CODE}${digits}`;
}

export function isValidPhone(phone: string): boolean {
  return PHONE_REGEX.test(phone);
}

export function formatPhoneForCountryInput(phone: string): string {
  const normalizedPhone = normalizePhone(phone);
  return normalizedPhone.startsWith(DEFAULT_PHONE_COUNTRY_CODE)
    ? normalizedPhone.slice(DEFAULT_PHONE_COUNTRY_CODE.length)
    : normalizedPhone;
}

function decodeBase64Url(input: string): string {
  const normalized = input.replace(/-/g, '+').replace(/_/g, '/');
  const paddingLength = (4 - (normalized.length % 4)) % 4;
  const padded = normalized + '='.repeat(paddingLength);

  if (typeof window !== 'undefined') {
    return window.atob(padded);
  }

  return Buffer.from(padded, 'base64').toString('binary');
}

export function getJwtExpiration(jwt: string): number | null {
  const segments = jwt.split('.');

  if (segments.length !== 3) {
    return null;
  }

  try {
    const payloadString = decodeBase64Url(segments[1]);
    const payload = JSON.parse(payloadString) as { exp?: number };

    if (typeof payload.exp !== 'number') {
      return null;
    }

    return payload.exp * 1000;
  } catch {
    return null;
  }
}
